import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import { PaymentOutlined, PeopleOutline, ShoppingCartOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { StatDisplay } from './StatDisplay';
import { PeriodDashboardData } from '../../api';
import { usePriceFormatter } from '../../common/usePriceFormatter';

export const PeriodStats = ({ data, label }: { data?: PeriodDashboardData; label: string }) => {
  const priceFormatter = usePriceFormatter();

  const { t } = useTranslation();
  const getTotalOrders = (data?: PeriodDashboardData) => (data?.private_orders || 0) + (data?.event_orders || 0);
  const getTotalGuests = (data?: PeriodDashboardData) =>
    (data?.total_persons_event || 0) + (data?.total_persons_private || 0);
  const price = priceFormatter(data?.total_income || 0, false, 'body1');
  return (
    <Grid item>
      <Typography display="block" mb={0.5} fontWeight={700}>
        {label}
      </Typography>
      <Grid container gap={2}>
        <StatDisplay
          value={getTotalOrders(data)}
          label={t('dashboard.orders')}
          icon={<ShoppingCartOutlined fontSize="small" color="action" />}
        />
        <StatDisplay
          value={getTotalGuests(data)}
          label={t('dashboard.persons')}
          icon={<PeopleOutline fontSize="small" color="action" />}
        />
        <StatDisplay
          value={price}
          label={t('dashboard.money')}
          icon={<PaymentOutlined fontSize="small" color="action" />}
        />
      </Grid>
    </Grid>
  );
};
